import styled from "styled-components";
import { colors } from "../../../../shared/styled/varibles";

export const VideoGallerySC = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const TitleSC = styled.div`
    width: 23rem;
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 2rem;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
    flex-grow: 0;
`;

export const GallerySC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.6rem;
    width: calc(100% - 23rem);
    padding-right: 1rem;
`;
